module.exports = __webpack_public_path__ + "img/Image - Header 5@2x(4).d83e66ec.png";